"use strict"

import {observable, action} from "mobx"

class RequestsFromLabsDialogStore {
	@observable isOpen = false

	@action open() {
		this.isOpen = true
	}

	@action close() {
		this.isOpen = false
	}
}

var singleton = new RequestsFromLabsDialogStore()
export default singleton
